<script lang="ts">
  import { CloudUpload } from '@lucide/svelte'
  import Tooltip from '../../../components/tooltip/Tooltip.svelte'
  import i18n from '../../../i18n'
  import { supportedFileExtensionsHtmlAccept } from '../../../constants/files'
  import { onMount } from 'svelte'
  import { useKeyboardListener } from '../../../hooks'
  import useUploadedFilesQueries from '../../../routes/project/hooks/useUploadedFilesQueries'
  import Button from '../../button/Button.svelte'

  let input: HTMLInputElement

  const { uploadFileMutation } = useUploadedFilesQueries()

  function handleClick() {
    input.click()
  }

  $effect(() => {
    return useKeyboardListener('i', {
      onKeyPress: handleClick,
      withControl: true,
    })
  })

  onMount(() => {
    const onDragOver = (e: DragEvent) => {
      e.preventDefault()
    }

    const onDrop = (e: DragEvent) => {
      if (e.dataTransfer?.files) {
        uploadFileMutation.mutate(e.dataTransfer.files)
        e.preventDefault()
      }
    }

    document.addEventListener('dragover', onDragOver)
    document.addEventListener('drop', onDrop)

    return () => {
      document.removeEventListener('dragover', onDragOver)
      document.removeEventListener('drop', onDrop)
    }
  })
</script>

<div class="container">
  <input
    bind:this={input}
    accept={supportedFileExtensionsHtmlAccept}
    multiple
    onchange={(e) => {
      const target = e.target as HTMLInputElement
      const files = Array.from(target.files ?? [])
      target.value = ''
      uploadFileMutation.mutate(files)
    }}
    type="file"
  />
  <Tooltip placement="top" title={$i18n.t('project.leftBar.printers.upload')}>
    <Button onclick={handleClick} size="icon-sm" variant="ghost">
      <CloudUpload />
    </Button>
  </Tooltip>
</div>

<style lang="scss">
  .container {
    input {
      display: none;
    }
  }
</style>
